<template>
    <div
        id="confirm-dialog"
        class="modal"
        :class="{ fade: !isVisible, show: isVisible }"
        tabindex="0"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <h4>Warning!</h4>
                    <p>
                        <i class="text-danger">{{ message }}</i>
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click.prevent="cancel()">Close</button>
                    <button
                        type="button"
                        class="btn btn-danger"
                        @click.prevent="confirm()"
                    >{{ dialogAction }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: String,
        dialogAction: String,
        isVisible: Boolean
    },
    methods: {
        confirm() {
            this.$emit("close", true)
        },
        cancel() {
            this.$emit("close", false)
        }
    }
}
</script>

<style scoped>
.modal {
    text-align: center;
    padding: 0;
    background: rgba(0, 0, 0, 0.6);
}

.modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -4px;
}

.modal-dialog {
    display: inline-block;
    text-align: left;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmDialog.vue